<template>
  <div>
    <CallHelpTel />
  </div>
  <div>
    <Search @upateShowNews="searchByKeyword"></Search>
  </div>
  <template v-for="item in advice.items" :key="item.id">
    <GrayBlock :article="item" justify="ArticlePage" />
  </template>

  <a-pagination
    v-model:current="advice.pagination.current"
    v-model:total="advice.pagination.total"
    v-model:pageSize="advice.pagination.pageSize"
    @change="changePage"
    :style="{ fontSize: fontSize.p + 'em' }"
  ></a-pagination>
</template>

<script>
import CallHelpTel from "../components/Home/CallHelpTel.vue";
import GrayBlock from "../components/ContentBlock.vue";
import Search from "../components/Search.vue";
import { ref, reactive, inject } from "vue";
import { apiSeaAdvices } from "@/api/api.js";
import { toArticleFormat } from "@/util/article";
import { message } from "ant-design-vue";
import { useStore } from "vuex";

export default {
  name: "Article",
  components: {
    GrayBlock,
    Search,
    CallHelpTel,
  },
  setup() {
    const store = useStore();
    let fontSize = inject("fontSize");

    let keyword = ref("");
    keyword.value = store.getters["getSearchKeyword"];
    const searchByKeyword = (str) => {
      advice.pagination.current = 1;
      keyword.value = str;
      fetchAdvice();
    };

    const advice = reactive({
      items: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
    });
    const fetchAdvice = async () => {
      store.dispatch("setSearchData", {
        keyword: keyword.value,
        page: advice.pagination.current,
      });
      try {
        const {
          data: { expertAdvices, currentPage, totalPage },
        } = await apiSeaAdvices({
          keyword: keyword.value,
          page: advice.pagination.current,
        });
        const adviceItems = expertAdvices.map((d) => toArticleFormat(d));

        advice.items = adviceItems;
        advice.pagination.current = currentPage;
        advice.pagination.total = totalPage * 10;
      } catch (error) {
        console.log(error);
        message.error("無法取得專家建議資料");
      }
    };

    advice.pagination.current = store.getters["getSearchPage"];
    fetchAdvice();

    const changePage = (page, pageSize) => {
      advice.pagination.pageSize = pageSize;
      advice.pagination.current = page;
      fetchAdvice();
    };

    return {
      searchByKeyword,
      changePage,
      advice,
      fontSize,
    };
  },
};
</script>
